import React from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

import styles from "./GpsCoordinates.module.styl";

const GpsCoordinates = ({
  latitude,
  longitude,
  unavailableText = "GPS coordinates unavailable"
}) => {
  const latitudeMissing =
    latitude === null ||
    latitude === undefined ||
    latitude === "";

  const longitudeMissing =
    longitude === null ||
    longitude === undefined ||
    longitude === "";

  if (latitudeMissing || longitudeMissing) {
    return (
      <div className={styles.unavailable}>
        <PublicOutlinedIcon />
        {unavailableText}
      </div>
    );
  }

  const lat = Number(latitude);
  const lon = Number(longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return (
      <div className={styles.unavailable}>
        <PublicOutlinedIcon />
        {unavailableText}
      </div>
    );
  }

  const valid = Number.isFinite(lat) && Number.isFinite(lon);

  if (!valid) {
    return (
      <div className={styles.unavailable}>
        <PublicOutlinedIcon />
        {unavailableText}
      </div>
    );
  }

  const span = 0.025;
  const bbox = [lon - span, lat - span, lon + span, lat + span].join(",");

  const embedUrl =
    `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(bbox)}`
    + `&layer=mapnik&marker=${encodeURIComponent(`${lat},${lon}`)}`;

  const openUrl =
    `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=15/${lat}/${lon}`;

  return (
    <div className={styles.root}>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.openButton}
          onClick={() => window.open(openUrl, "_blank", "noopener,noreferrer")}
        >
          Open map
          <OpenInNewIcon fontSize="inherit" />
        </button>
      </div>

      <div className={styles.mapFrameWrap}>
        <iframe
          title={`GPS location ${lat}, ${lon}`}
          className={styles.mapFrame}
          src={embedUrl}
          loading="lazy"
          referrerPolicy="no-referrer"
        />

        <div className={styles.coordinateBadge}>
          {lat.toFixed(5)}, {lon.toFixed(5)}
        </div>
      </div>
    </div>
  );
};

export default GpsCoordinates;
export { GpsCoordinates };